import React, { useState } from 'react';
import { connect } from 'react-redux'
import { compose } from 'recompose';

import { withStyles, Avatar } from '@material-ui/core';
import parseImagUrl from "../../../../components/Common/parseImagUrl";
import goTo from '../../../../actions/goTo';
import GeneralButton from '../../../../components/Common/AllButton/AllButton';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    container: {
        marginTop: 10,
        marginRight: 10,
        width: 423,
        maxWidth: 423,
        minWidth: 423,
        height: 360,
        position: 'relative',
        borderRadius: 4,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
        '&:last-child': {
            marginRight: 0
        },
        '&:nth-child(3)': {
            marginRight: 0
        },
        
    },
    overlay: {
        position: 'absolute',
        backgroundImage: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 200%, rgba(0, 0, 0, 0.7), #000000)',
        width: 'auto',
        height: 'auto',
        top: 0,
        right: 0,
        left: 0,
        bottom: 0
    },
    title: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
            textDecorationColor: 'ffffff'
        },
        marginTop: 150,
        fontFamily: 'Rubik',
        fontSize: 28,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#ffffff',
    },
    subtitle: {
        margin: '12px 16px 18px 32px',
        opacity: 0.7,
        fontFamily: 'Rubik',
        fontSize: 16,
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#ffffff',
    },
    followers: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    subsribe: {
        marginTop: 24,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    avatar: {
        width: 24,
        height: 24,
        marginLeft: -8
    },
    moreAvatars: {
        marginLeft: 4,
        height: 24,
        background: 'transparent',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        color: '#fff',
        fontWeight: 'normal',
        fontSize: 12,
        fontStyle: 'normal',
        fontFamily: 'Rubik',
        lineHeight: 1.33,
        fontStretch: 'normal',
        letterSpacing: 'normal',
    },
    collectionFaces: { display: 'flex' },
    subsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: 'transparent',
        border: 'solid 2px #e0e0e0',
        color: '#fff',
        '&:hover': {
            background: '#FFF',
            color: '#21212d',
        },
    },
    subsribeButtomText: {
        fontSize: 14,
        lineHeight: 2,
        letterSpacing: 1.5,
        marginTop: 2
    },
    unsubsribeButtomContainer: {
        width: 130,
        height: 38,
        backgroundColor: '#fff',
        border: 'solid 2px #fff',
        color: '#21212d',
        '&:hover': {
            background: 'transparent',
            color: '#fff',
        },
    }
});


const checkIfSubscribed = (tagInfo, userData) => {    
    if(userData.subscribedTags && userData.subscribedTags.length && tagInfo.tag){
        return userData.subscribedTags.some(t => (t.tag || "").toLowerCase() === tagInfo.tag.toLowerCase())
    }
    return false
}

const TrendingTopic = (props) => {
    const {classes, topic, cloudfront, dispatch, userData, subscribe, t} = props
    const [backgroundLink] = useState(parseImagUrl(cloudfront, topic.backgroundImage, 500, topic.backgroundImage))
    const isSubsribed = checkIfSubscribed(topic.meta, userData)
    const openCollectionView = () => {
        goTo('#' + topic.title, dispatch)();
    }
    const renderCollectionFaces = () => {
        return <div data-intrcm-id="TrendingTopic_yfrsxep8" className={classes.collectionFaces}>
            {<div data-intrcm-id="TrendingTopic_xbrxqh4t" className={classes.moreAvatars}>{`${topic.followers} ${t('Subscribers')}`}</div>}
        </div>
    }
    const onClickGeneral = () => {
        if(isSubsribed) {
            openCollectionView()
            return
        }
        subscribe(topic.meta, openCollectionView)
    }
    const renderSubscribeButton = () => {
        const title = isSubsribed ? t('VIEW') : t('SUBSCRIBE')
        const containerStyle = isSubsribed ? classes.unsubsribeButtomContainer : classes.subsribeButtomContainer
        return <GeneralButton onClick={onClickGeneral} containerStyle={containerStyle} textStyle={classes.subsribeButtomText} title={title} />
    }

        return (
            <div data-intrcm-id="TrendingTopic_f8rk8jj9" style={{backgroundImage: `url(${backgroundLink})`}} className={classes.container}>
          <div data-intrcm-id="TrendingTopic_6lknek3i" className={classes.overlay}>
              <div data-intrcm-id="TrendingTopic_tksxkere" onClick={openCollectionView} className={classes.title}>{topic.title}</div>
              <div data-intrcm-id="TrendingTopic_i8he3imu" className={classes.subtitle}>{topic.subtitle}</div>
              <div data-intrcm-id="TrendingTopic_q100tnvc" className={classes.followers}>
                {renderCollectionFaces()}
              </div>
              <div data-intrcm-id="TrendingTopic_xnqiljjd" className={classes.subsribe}>
                {renderSubscribeButton()}
              </div>
          </div>
          </div>
        )
}

const mapStateToProps = (state) => ({
    profileData: state.userData.profileData,
    userData: state.userData,
    cloudfront: state.globalData.cloudfront
})


const mapDispatchToProps = dispatch => ({ dispatch })

export default compose(withStyles(styles, {withTheme: true}),
    withTranslation('groupDrawerTranslate'),
    connect(mapStateToProps, mapDispatchToProps))(TrendingTopic);
